import PerfectScrollbar from "react-perfect-scrollbar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { toggleSidebar } from "../../store/themeConfigSlice";
import { useState, useEffect } from "react";
import IconMenuChat from "../Icon/Menu/IconMenuChat";
import IconMenuUsers from "../Icon/Menu/IconMenuUsers";
import IconLogout from "../Icon/IconLogout";
import HeyPopWordmark from "../HeyPopWordmark";
import IconQuestion from "../Icon/IconQuestion";
import { MdCollections, MdDashboard, MdHowToReg, MdPublic } from "react-icons/md";
import { BsFillCollectionFill } from "react-icons/bs";
import { FaHistory, FaUser, FaLock } from "react-icons/fa";
import { LuMessagesSquare } from "react-icons/lu";

const Sidebar = () => {
  const [currentMenu, setCurrentMenu] = useState("");
  const [errorSubMenu, setErrorSubMenu] = useState(false);
  const themeConfig = useSelector((state) => state.themeConfig);
  const semidark = useSelector((state) => state.themeConfig.semidark);
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const sidebarToggle = useSelector((state) => state.themeConfig.sidebar);
  console.log("sidebarToggle", sidebarToggle);

  const toggleMenu = (value) => {
    setCurrentMenu((oldValue) => {
      return oldValue === value ? "" : value;
    });
  };

  useEffect(() => {
    const selector = document.querySelector(
      '.sidebar ul a[href="' + window?.location.pathname + '"]'
    );
    if (selector) {
      selector.classList.add("active");
      const ul = selector.closest("ul.sub-menu");
      if (ul) {
        let ele = ul.closest("li.menu").querySelectorAll(".nav-link") || [];
        if (ele.length) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1024 && themeConfig.sidebar) {
      dispatch(toggleSidebar());
    }
    // eslint-disable-next-line
  }, [location]);

  return (
    <div className={semidark ? "dark" : ""}>
      <nav
        className={` sidebar fixed min-h-screen overflow-hidden h-full top-0 bottom-0 w-[260px] z-50 transition-all duration-300 border-r border-[#E2E2E2] ${
          semidark ? "text-white-dark" : ""
        }`}
      >
        <div className="h-full">
          <div className="flex justify-center items-center px-4 py-3">
            <NavLink
              to="/dashboard"
              className="main-logo items-center gap-2 shrink-0 flex "
            >
              {/* <span className="text-xl ltr:ml-1.5 rtl:mr-1.5 font-semibold align-middle lg:inline dark:text-white-light">
                SLASH STAR
              </span> */}
              <HeyPopWordmark size={28} />
            </NavLink>
          </div>
          <PerfectScrollbar className="h-[calc(100vh-50px)] relative">
            <div className="flex flex-col justify-between h-full">
              <ul className="relative font-semibold space-y-0.5 p-4 py-0">
                <li className="nav-item">
                  <ul>
                    <li className="nav-item">
                      <NavLink to="/dashboard" className="group">
                        <div className="flex items-center">
                          <MdDashboard className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3  dark:text-[#506690] dark:group-hover:text-white-dark">
                            {/* {t("mailbox")} */}
                            Dashboard
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    {/* <li className="nav-item">
                      <NavLink to="/history" className="group">
                        <div className="flex items-center">
                          <FaHistory className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            History
                          </span>
                        </div>
                      </NavLink>
                    </li> */}
                    <li className="nav-item">
                      <NavLink to="/userdetails" className="group">
                        <div className="flex items-center">
                          {/* <FaHistory className="group-hover:!text-primary shrink-0" /> */}
                          <FaUser className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            {/* {t("chat")} */}
                            User
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/log-messages" className="group">
                        <div className="flex items-center">
                          {/* <FaHistory className="group-hover:!text-primary shrink-0" /> */}
                          <LuMessagesSquare className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            {/* {t("chat")} */}
                            Log Messages
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/log-registrations" className="group">
                        <div className="flex items-center">
                          <MdHowToReg className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            Log Registrations
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/countries" className="group">
                        <div className="flex items-center">
                          <MdPublic className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            Countries
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/api-docs" className="group">
                        <div className="flex items-center">
                          <IconQuestion className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            API Docs
                          </span>
                        </div>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/security/2fa" className="group">
                        <div className="flex items-center">
                          <FaLock className="group-hover:!text-primary shrink-0" />
                          <span className="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">
                            2FA Security
                          </span>
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="px-4">
                {/* <li className="nav-item mb-6"> */}
                {/* <Link to="/auth/boxed-signin" className="group text-danger"> */}
                <div className="flex items-center w-full gap-2 justify-center">
                  {/* <IconLogout className="rotate-90 shrink-0 !text-danger group-hover:!text-primary" /> */}
                  {/* <span className="text-danger group-hover:text-primary font-semibold"> */}
                  {/* {t("scrumboard")} */}
                  {/* Sign Out */}
                  {/* </span> */}
                </div>
                {/* </Link> */}
                {/* </li> */}
              </ul>
            </div>
          </PerfectScrollbar>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
